<template>
    <v-sheet color="#B5B5B5" class="grid-container container--fluid"
             ref="container"
             :class="{'grid-contailer__inited': isInitialized}">
        <div ref="scene" class="scene" v-show="!errorLoadingGrid">
            <div class="params" v-if="editable">
                <div class="d-flex">
                    <v-btn-toggle
                        v-model="editMode"
                        dense
                        group
                    >
                        <div class="d-flex flex-column">
                            <p class="v-size--small align-self-center mb-0 mt-1">Скважины</p>
                            <div class="d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group">
                                <v-btn value="move">
                                    <v-icon>mdi-cursor-move</v-icon>
                                </v-btn>
                                <v-btn value="add">
                                    <v-icon>mdi-map-marker-plus</v-icon>
                                </v-btn>
                                <v-btn value="delete">
                                    <v-icon>mdi-map-marker-minus</v-icon>
                                </v-btn>
                                <v-btn value="edit">
                                    <v-icon>mdi-map-marker-question</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <v-divider vertical></v-divider>
                        <div class="d-flex flex-column">
                            <p class="v-size--small align-self-center mb-0 mt-1">Перетоки</p>
                            <div class="d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group">
                                <v-btn value="connect">
                                    <v-icon>mdi-vector-line</v-icon>
                                </v-btn>
                                <v-btn value="disconnect">
                                    <v-icon>mdi-vector-polyline-minus</v-icon>
                                </v-btn>
                            </div>
                        </div>
                        <v-divider vertical></v-divider>
                        <div class="d-flex flex-column">
                            <p class="v-size--small align-self-center mb-0 mt-1">Инфо</p>
                            <div class="d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group">
                                <v-btn value="cell">
                                    <v-icon>mdi-square-circle-outline</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </v-btn-toggle>
                    <v-divider vertical></v-divider>
                    <div class="d-flex flex-column" v-if="showExtraMenu">
                        <p class="v-size--small align-self-center mb-0 mt-1">Прочее</p>
                        <div class="d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group">
                            <v-menu offset-y :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon
                                           v-bind="attrs"
                                           v-on="on"
                                           class="mx-2 mt-1"
                                    >
                                        <v-icon>mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <slot name="extraMenu"></slot>
                            </v-menu>
                        </div>
                    </div>
                    <v-divider vertical v-if="showExtraMenu"></v-divider>
                    <v-spacer></v-spacer>
                    <div class="history-slider mt-1">
                        <v-slider v-if="injectionData && injectionData.t"
                                  v-model="historyIndex"
                                  min="0"
                                  :max="injectionData.t.length-1"
                                  step="1"
                                  label="История"
                                  :hint="String(injectionData.t[historyIndex])"
                                  persistent-hint
                        ></v-slider>
                    </div>
                    <v-menu offset-y :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon
                                   v-bind="attrs"
                                   v-on="on"
                                   class="ml-2 mt-1"
                            >
                                <v-icon>mdi-cog</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-switch v-model="showPlane" hide-details class="mt-0"></v-switch>
                                </v-list-item-icon>
                                <v-list-item-title>Сетка</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-switch v-model="showAxis" hide-details class="mt-0"></v-switch>
                                </v-list-item-icon>
                                <v-list-item-title>Оси</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-switch v-model="showMesh" hide-details class="mt-0"></v-switch>
                                </v-list-item-icon>
                                <v-list-item-title>Пласт</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-switch v-model="showConnectionsHeightDiff" hide-details class="mt-0"></v-switch>
                                </v-list-item-icon>
                                <v-list-item-title>Разность высот перетоков</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-switch v-model="connectionsAutoload" hide-details class="mt-0"></v-switch>
                                </v-list-item-icon>
                                <v-list-item-title>Автообновление соединений</v-list-item-title>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field v-model="wellMarkerSize"
                                              type="number"
                                              label="Размер маркера"
                                              outlined
                                              dense
                                              hide-details
                                ></v-text-field>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field v-model="fontSize"
                                              type="number"
                                              label="Размер шрифта"
                                              outlined
                                              dense
                                              hide-details
                                ></v-text-field>
                            </v-list-item>
                            <v-list-item>
                                <v-text-field v-model="zScaleRaw"
                                              type="number"
                                              label="Масштаб по Z"
                                              outlined
                                              dense
                                              hide-details
                                ></v-text-field>
                            </v-list-item>
                            <v-list-item v-if="showMesh">
                                <v-select label="Цвет сетки"
                                          outlined
                                          dense
                                          hide-details
                                          v-model="selectedProperty"
                                          return-object :items="availableProperties"
                                ></v-select>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <v-btn-toggle v-if="editMode === 'move'"
                              v-model="moveAxis"
                              dense
                              group
                              multiple
                >
                    <v-btn value="x">X</v-btn>
                    <v-btn value="y">Y</v-btn>
                    <v-btn value="z">Z</v-btn>
                </v-btn-toggle>
            </div>
        </div>
        <v-progress-circular v-if="isLoading || isProcessing || !isInitialized"
                             color="white"
                             indeterminate
                             size="64"
        ></v-progress-circular>
    </v-sheet>
</template>

<script>
import * as THREE from 'three';
import {RectangleGridHelper} from "@/components/Grid/RectangleGridHelper";
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {DragControls} from 'three/examples/jsm/controls/DragControls';
import TextSprite from '@seregpie/three.text-sprite';
import {getNodeLayers, getWellXYZ, ijkToXyz, parseGltf, setMaterial} from "@/utils";
import {MultisizeAxesHelper} from "@/plugins/MultisizeAxisHelper";
import {TYPE_IMAGINARY, TYPE_INJECT, TYPE_PRODUCE} from "@/utils";

const COLOR_NODE = 0xffff00;
const COLOR_NODE_HOVER = 0x0000ff;
const COLOR_CONNECTION_HOVER = COLOR_NODE_HOVER;
const COLOR_WELL_PATH = 0xff0000;
const COLOR_CONNECTION = 0x000000;
const COLOR_LABEL_PRODUCER = '#00ff00';
const COLOR_LABEL_INJECTOR = '#ff0000';
const COLOR_LABEL_IMAGINARY = '#0000ff';
const COLOR_LABEL = '#000000';
const COLOR_LAYER_PLANE = 0x00ff00;

class MultiGroup extends THREE.Group {
    constructor() {
        super();
        this.type = 'MultiGroup';
    }

    add(object) {
        if (arguments.length > 1) {
            for (let i = 0; i < arguments.length; i++) {
                this.add(arguments[i]);
            }

            return this;

        }

        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }

        if (object && object.isObject3D) {
            object.parent = this;
            this.children.push(object);

            object.dispatchEvent({type: 'added'});
        }
        else {
            console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        }

        return this;
    }
}

export default {
    props: [
        'problemId',
        'inputShowWells',
        'inputShowMesh',
        'inputShowConnections',
        'showExtraMenu',
        'activeWellId',
        'inputWells',
        'inputSize',
        'inputCellSize',
        'problem',
        'isParsed',
        'connections',
        'nodes',
        'gridMeshFile',
        'editable',
        'injectionData',
    ],
    data() {
        let properties = [
            {text: 'Средняя проницаемость', value: 'mean_permeability'},
            {text: 'Пористость', value: 'porosity'},
            {text: 'Начальная водонасыщенность Sw', value: 'sw'},
        ];

        return {
            editMode: this.editable ? 'edit' : 'cell',
            prevEditMode: null,
            moveAxis: ['x', 'y'],
            background: new THREE.Color(0xe1e1e1),
            defaultCellRGBColor: [0, 0, 255],
            showWells: Boolean(this.inputShowWells),
            showPlane: true,
            showAxis: false,
            showMesh: Boolean(this.inputShowMesh),
            showConnections: Boolean(this.inputShowConnections),
            showConnectionsHeightDiff: false,
            renderer: null,
            isRendering: false,
            isInitializing: false,
            isInitialized: false,
            scene: null,
            light: null,
            camera: null,
            raycaster: null,
            mesh: null,
            hoverCube: null,
            inputCubes: null,
            controls: null,
            dragControls: null,
            arrangedCells: null,
            testGrid: {
                size: [6, 6, 0],
                cells: [
                    {
                        active: true,
                        ijk_coords: [1, 1, 0],
                        porosity: null,
                        size: [8, 8, 4],
                    }
                ]
            },
            properties,
            selectedProperty: properties[0],
            hoverCellIndex: null,
            textures: null,
            wellObjects: [],
            nodeGroup: null,
            wellsGroup: null,
            layerGroup: null,
            connectionGroup: null,
            connectionObjects: [],
            hoverObject: null,
            wells: this.inputWells || [],
            prevProblemId: null,
            selectedWell: null,
            selectedNodeIndex: null,
            selectedMesh: null,
            cameraPosition: null,
            historyIndex: null,
            wrapperWidth: null,
            wrapperHeight: null,
            zScaleRaw: 1,
            arrowHeadSize: null
        };
    },
    created() {
        if (!this.inputWells) {
            this.wells = this.$store.state.grid.wells;
        }
    },
    async mounted() {
        await this.updateWrapperDimensions();
        await this.loadTextures();
        await this.updateGrid();
    },
    watch: {
        isLoading() {
            if (!this.isLoading && !this.isProcessing) {
                this.updateGrid();
            }
        },
        showPlane() {
            this.updateGrid();
        },
        showAxis() {
            this.updateGrid();
        },
        showMesh() {
            this.updateGrid();
        },
        grid() {
            this.updateGrid();
        },
        connections() {
            this.updateGrid();
        },
        nodes() {
            this.updateGrid();
        },
        wellMarkerSize() {
            this.updateGrid();
        },
        fontSize() {
            this.updateGrid();
        },
        historyIndex() {
            this.updateGrid();
        },
        zScale() {
            this.updateGrid();
        },
        showConnectionsHeightDiff() {
            this.updateGrid();
        },
        async selectedProperty() {
            this.updateGridMaterial(this.selectedProperty.value);
        },
        activeWellId() {
            if (!this.activeWellId) {
                return;
            }

            if (!this.wells) {
                return;
            }

            if (!this.controls) {
                return;
            }

            let activeWell = this.wells.find(well => well.id === this.activeWellId);
            if (!activeWell) {
                return;
            }

            let x = activeWell.x_coord;
            let y = activeWell.y_coord;
            let z = activeWell.h_well_net_thickness;

            this.controls.target.set(x, y, z);
            this.controls.update();
            this.render();
        },
        inputWells() {
            this.wells = [].concat(this.inputWells);
            this.updateGrid();
        },
        async problemId() {
            if (this.problemId !== this.prevProblemId) {
                this.prevProblemId = this.problemId;
                await this.loadTextures();
            }
        },
        editMode() {
            this.onMouseMove(null, this.prevEditMode);
            this.prevEditMode = this.editMode;

            if (this.editMode === 'move') {
                if (this.dragControls) {
                    this.dragControls.activate();
                }
            }
            else {
                if (this.dragControls) {
                    this.dragControls.deactivate();
                }
            }
        }
    },
    methods: {
        updateWrapperDimensions() {
            let interval;
            let msPassed = 0
            let msWait = 100;
            let prevHeight = null;

            return new Promise(resolve => {
                interval = setInterval(() => {
                    let box = typeof (this.$refs['container']) !== 'undefined'
                        ? this.$refs.container.$el.getBoundingClientRect()
                        : null;

                    let waitSuccess = box && box.width > 0 && box.height > 0 && prevHeight === box.height;
                    prevHeight = box.height;
                    if (waitSuccess) {
                        clearInterval(interval);
                        this.wrapperWidth = box.width;
                        this.wrapperHeight = box.height;
                        resolve();
                    }
                }, msWait);
            });
        },
        loadTextures() {
            if (!this.problemId) {
                return;
            }

            this.materials = {};
            this.textures = {};
            let loader = new THREE.TextureLoader();
            for (let propItem of this.properties) {
                let url = '/storage/mesh/' + this.problemId + '/' + propItem.value + '.png';
                try {
                    loader.load(url,
                        (texture) => {
                            this.$set(this.textures, propItem.value, texture);
                        },
                    );
                } catch (e) {
                    continue;
                }
            }
        },
        updateGridMaterial(propCode) {
            if (!this.textures) {
                return;
            }

            if (typeof (this.textures[propCode]) === 'undefined') {
                return;
            }

            let texture = this.textures[propCode];
            setMaterial(this.mesh, new THREE.MeshBasicMaterial({
                map: texture,
                polygonOffset: true,
                polygonOffsetFactor: -1,
                polygonOffsetUnits: -1
            }));
            this.render();
        },
        setupAfterRenderCallback(rendererDomElement, callback) {
            callback = callback.bind(this);
            let context = rendererDomElement.getContext('webgl2');
            if (typeof (context.__clear) !== 'undefined') {
                context.clear = context.__clear;
                delete context.__clear;
            }

            context.__clear = context.clear;
            context.clear = (arg) => {
                context.__clear(arg);
                callback();
            }
        },
        waitUntilRenderIsFinished() {
            if (!this.isRendering) {
                return;
            }

            let state = this;
            let checkState = (state, resolve, reject) => {
                if (!state.isRendering) {
                    resolve();
                }

                window.requestIdleCallback(() => checkState(state, resolve, reject), {timeout: 100});
            }

            return new Promise((resolve, reject) => {
                checkState(state, resolve, reject);
            });
        },
        async waitUntilSceneAppears() {
            if (this.$refs.scene) {
                return;
            }

            let state = this;
            let checkState = (state, resolve, reject) => {
                if (state.$refs.scene) {
                    resolve();
                }

                window.requestIdleCallback(() => checkState(state, resolve, reject), {timeout: 100});
            }

            return new Promise((resolve, reject) => {
                checkState(state, resolve, reject);
            });
        },
        async initProperties() {
            await this.$store.commit('grid/setGridProperty', {
                'color_property': this.selectedProperty.value
            });
        },
        async init() {
            this.isInitializing = true;
            await this.waitUntilSceneAppears();
            await this.initProperties();
            if (this.scene) {
                this.reset();
            }

            let scene = new THREE.Scene();
            scene.background = this.background;

            const ambientLight = new THREE.AmbientLight(0x909090);
            scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(0xffffff);
            directionalLight.position.set(700, 1000, 1500);
            directionalLight.lookAt(0, 0, 0);
            scene.add(directionalLight);

            if (!this.camera) {
                let viewportWidth = this.$el.clientWidth;
                let viewportHeight = this.$el.clientHeight;
                let renderer = new THREE.WebGLRenderer({
                    antialias: false,
                    powerPreference: "high-performance",
                });
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setSize(viewportWidth, viewportHeight);
                this.$refs.scene.appendChild(renderer.domElement);
                if (this.editable) {
                    this.$refs.scene.addEventListener('pointermove', this.onMouseMove);
                    this.$refs.scene.addEventListener('click', this.onClick);
                }

                let fov = 45;
                let near = 0.1;
                let far = 30000;
                let camera = new THREE.PerspectiveCamera(fov, window.innerWidth / window.innerHeight, near, far);
                camera.up.set(0, 0, 1); //Ось Z смотрит вверх
                camera.position.set(700, 1500, 1000);
                camera.lookAt(0, 0, 0);

                let cameraControls = new OrbitControls(camera, renderer.domElement);
                cameraControls.addEventListener('change', this.cameraChange);

                this.controls = cameraControls;
                this.camera = camera;
                this.renderer = renderer;
                this.light = directionalLight;
                this.raycaster = new THREE.Raycaster();
            }
            else {
                this.$refs.scene.append(this.renderer.domElement);
            }

            this.scene = scene;
            this.fontSize = this.getFontSize();
            this.arrowHeadSize = this.getFontSize();
            this.wellMarkerSize = this.getMarkerSize();
            this.render();
            this.isInitializing = false;
        },
        async afterInit() {
            if (this.editable) {
                if (this.dragControls) {
                    this.dragControls.dispose();
                    this.dragControls = null;
                }

                let dragObjects = this.nodeGroup.children;
                let controls = new DragControls(dragObjects, this.camera, this.renderer.domElement);
                controls.addEventListener('hoveron', event => {
                    event.object.material.color.set(COLOR_NODE_HOVER);
                    this.fastRender();
                });

                controls.addEventListener('hoveroff', event => {
                    event.object.material.color.set(COLOR_NODE);
                    this.fastRender();
                });

                controls.addEventListener('dragstart', event => {
                    this.controls.enabled = false;
                });

                controls.addEventListener('drag', event => {
                    this.fastRender();
                });

                controls.addEventListener('dragend', event => {
                    this.controls.enabled = true;
                    let nodeData = event.object.userData;
                    if (!nodeData) {
                        return;
                    }

                    let well = this.wells.find(well => well.id === nodeData.wellId)
                    if (!well) {
                        return;
                    }

                    let node = well.nodes[nodeData.nodeIndex];

                    if (this.moveAxis.includes('x')) {
                        node.x_coord = event.object.position.x;
                    }

                    if (this.moveAxis.includes('y')) {
                        node.y_coord = event.object.position.y;
                    }

                    if (this.moveAxis.includes('z')) {
                        node.z_coord_relative = event.object.position.z;
                    }
                });

                this.dragControls = controls;
            }
            this.isInitialized = true;
        },
        reset() {
        },
        cameraChange() {
            this.cameraPosition = this.camera.position;
            this.render();
        },
        fastRender() {
            this.renderer.setSize(this.wrapperWidth, this.wrapperHeight);
            this.renderer.render(this.scene, this.camera);
        },
        render() {
            this.setupAfterRenderCallback(this.renderer.domElement, this.endRenderingState);
            this.startRenderingState();
            this.fastRender();
            return this.waitUntilRenderIsFinished();
        },
        cellIndexToIjk(cellIndex) {
            if (!this.ijkIndex) {
                return null;
            }

            let [, i, j, k] = this.ijkIndex[cellIndex];
            return [i, j, k];
        },
        ijkToXyz(i, j, k) {
            return ijkToXyz(i, j, k, this.cellSize);
        },
        addGridToScene() {
            if (!this.gridSize) {
                return;
            }

            let extraGridCells = 3;
            let [cellsX, cellsY, cellsZ] = this.gridSize;
            cellsX += extraGridCells;
            cellsY += extraGridCells;
            cellsZ += extraGridCells;

            let sizeX = cellsX * this.cellSize[0];
            let sizeY = cellsY * this.cellSize[1];
            let sizeZ = cellsZ * this.cellSize[2];

            const gridHelperXZ = new RectangleGridHelper([sizeX, sizeZ], [cellsX, cellsZ]);
            this.scene.add(gridHelperXZ);

            const gridHelperXY = new RectangleGridHelper([sizeX, sizeY], [cellsX, cellsY]);
            gridHelperXY.rotateX(-Math.PI / 2);
            this.scene.add(gridHelperXY);

            const gridHelperYZ = new RectangleGridHelper([sizeY, sizeZ], [cellsY, cellsZ]);
            gridHelperYZ.rotateZ(Math.PI / 2);
            this.scene.add(gridHelperYZ);
        },
        addAxisToScene() {
            let arrowLength = [0, 1, 2].map(index => {
                return this.cellSize[index] * (this.gridSize[index] + 5);
            });

            let axes = new MultisizeAxesHelper(arrowLength[0], arrowLength[1], arrowLength[2]);
            this.scene.add(axes);

            let textX = new TextSprite({
                fontFamily: 'Arial, Helvetica, sans-serif',
                color: '#ff0000',
                fontSize: this.getFontSize(),
                text: 'X (I)',
            });
            textX.position.set(arrowLength[0] + 1, 0, 0);
            this.scene.add(textX);

            let textY = new TextSprite({
                fontFamily: 'Arial, Helvetica, sans-serif',
                color: '#00ff00',
                fontSize: this.getFontSize(),
                text: 'Y (J)',
            });
            textY.position.set(0, arrowLength[1] + 1, 0);
            this.scene.add(textY);

            let textZ = new TextSprite({
                fontFamily: 'Arial, Helvetica, sans-serif',
                color: '#0000ff',
                fontSize: this.getFontSize(),
                text: 'Z (K)',
            });
            textZ.position.set(0, 0, arrowLength[2] + 1);
            this.scene.add(textZ);
        },
        addTestCubeXYZ(x, y, z) {
            let boxSize = this.cellSize;
            let squareBox = new THREE.BoxBufferGeometry(boxSize[0], boxSize[1], boxSize[2]);
            let material = new THREE.MeshBasicMaterial({color: 0xffff00});
            let cube = new THREE.Mesh(squareBox, material);
            cube.position.set(x + boxSize[0] / 2, y + boxSize[1] / 2, z + boxSize[2] / 2);
            this.scene.add(cube);
        },
        addHoverCubeToCell(cellIndex) { //, ix, iy, iz) {
            let [i, j, k] = this.cellIndexToIjk(cellIndex);
            let [x, y, z] = this.ijkToXyz(i, j, k);
            let boxSize = this.cellSize;
            let bitLargerScale = 1.05;
            boxSize = boxSize.map(dim => dim * bitLargerScale);

            if (!this.hoverCube) {
                let squareBox = new THREE.BoxBufferGeometry(boxSize[0], boxSize[1], boxSize[2]);
                let material = new THREE.MeshBasicMaterial({color: 0xffff00});
                this.hoverCube = new THREE.Mesh(squareBox, material);
                this.hoverCube.position.set(x, y, z);
                this.scene.add(this.hoverCube);
            }
            else {
                this.hoverCube.position.set(x, y, z);
            }
        },
        updateCameraDistance() {
            if (!this.camera) {
                return;
            }

            if (this.cameraPosition) {
                return;
            }

            let targetBox = null;
            if (this.gridGeometry) {
                targetBox = this.gridGeometry.boundingBox.clone();
            }
            if (!this.showMesh) {
                let allObjects = new THREE.Group();
                for (let well of this.wellObjects) {
                    if (well.nodes) {
                        for (let sphere of well.nodes) {
                            allObjects.add(sphere.clone());
                        }
                    }
                }

                for (let connection of this.connectionObjects) {
                    allObjects.add(connection.clone());
                }

                targetBox = new THREE.Box3();
                targetBox.setFromObject(allObjects);
            }

            if (!targetBox) {
                return;
            }

            let fov = this.camera.fov * (Math.PI / 180);
            let size = targetBox.max.clone().sub(targetBox.min);
            let boxSize = Math.max(Math.abs(size.x), Math.abs(size.y), Math.abs(size.z));
            let scaleAtView = 0.7;
            boxSize = boxSize / scaleAtView;

            let boxCenter = targetBox.min.clone().add(targetBox.max).multiplyScalar(0.5);
            let currentDistance = this.camera.position.distanceTo(boxCenter);
            let newDistance = Math.abs(boxSize / Math.sin(fov / 2));
            let scale = newDistance / currentDistance;

            this.camera.position.multiplyScalar(scale);
            this.camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);
            if (this.controls) {
                this.controls.target.set(boxCenter.x, boxCenter.y, boxCenter.z);
                this.controls.update();
            }
        },
        async addCubesToScene() {
            if (!this.gridMeshFile) {
                return;
            }

            if (!this.showMesh) {
                return;
            }

            try {
                this.mesh = await parseGltf(this.gridMeshFile, this.renderer);
            } catch (e) {
                this.mesh = null;
            }

            this.updateGridMaterial(this.selectedProperty.value);
            this.scene.add(this.mesh);

            let wireframeGeometry = new THREE.EdgesGeometry(this.mesh.geometry);
            let wireframeMaterial = new THREE.LineBasicMaterial({color: 0x000000});
            let wireframe = new THREE.LineSegments(wireframeGeometry, wireframeMaterial);
            this.scene.add(wireframe);
        },
        getFontSize() {
            let fontSize = this.fontSize
                ? this.fontSize
                : Math.min.apply(null, this.cellSize) / 2;

            let minFontSize = 0.5;
            return Math.max(fontSize, minFontSize);
        },
        getMarkerSize() {
            if (this.wellMarkerSize) {
                return this.wellMarkerSize;
            }

            let size = Math.min.apply(null, this.cellSize) / 4;
            if (this.cellSize && this.cellSize.length > 2 && this.cellSize[0] === this.cellSize[1]) {
                size = this.cellSize[0] / 4;
            }

            return size;
        },
        getHistoryType(well) {
            if (!well || !this.injectionData) {
                return null;
            }

            if (!this.injectionData[well.id]) {
                return null;
            }

            let index = this.historyIndex || 0;
            let flow = this.injectionData[well.id][index];
            if (flow > 0) {
                return TYPE_INJECT;
            }

            if (flow < 0) {
                return TYPE_PRODUCE;
            }

            return null;
        },
        addWellsToScene() {
            if (!this.wells) {
                return;
            }

            this.wellObjects = [];
            this.nodeGroup = new MultiGroup();
            this.wellsGroup = new MultiGroup();
            for (let well of this.wells) {
                let xyzPoints = well.nodes.map(node => {
                    return getWellXYZ(node, this.gridProperties);
                });
                if (!xyzPoints || (xyzPoints && xyzPoints.length === 0)) {
                    continue;
                }

                let cellHeight = (this.cellSize ? this.cellSize[2] : 1) * this.zScale;
                let calloutLineLength = 3 * this.getMarkerSize();
                let gridHeight = this.gridSize[2] * cellHeight;

                let startPoint = xyzPoints[0];
                let endPoint = xyzPoints[xyzPoints.length - 1];
                let headTipPoint = [startPoint[0], startPoint[1], gridHeight + calloutLineLength];
                let endTipPoint = [endPoint[0], endPoint[1], 0 - calloutLineLength];

                xyzPoints.unshift(headTipPoint);
                xyzPoints.push(endTipPoint);

                let points3d = xyzPoints.map(xyzPoint => {
                    let [x, y, z] = xyzPoint;
                    return new THREE.Vector3(x, y, z * this.zScale);
                });

                let material = new THREE.LineBasicMaterial({color: COLOR_WELL_PATH});
                let geometry = new THREE.BufferGeometry().setFromPoints(points3d);
                let path = new THREE.Line(geometry, material);
                path.userData = {type: 'path', wellId: well.id};

                let fontSize = this.getFontSize();
                let labelColor = well.type === TYPE_IMAGINARY
                    ? COLOR_LABEL_IMAGINARY
                    : COLOR_LABEL

                let historyType = this.getHistoryType(well);
                if (historyType === TYPE_PRODUCE) {
                    labelColor = COLOR_LABEL_PRODUCER;
                }

                if (historyType === TYPE_INJECT) {
                    labelColor = COLOR_LABEL_INJECTOR;
                }

                let label = new TextSprite({
                    fontFamily: 'Arial, Helvetica, sans-serif',
                    color: labelColor,
                    fontSize,
                    text: well.id,
                });
                let labelPosition = points3d[0];
                label.position.set(labelPosition.x, labelPosition.y, labelPosition.z + fontSize);
                label.userData = {type: 'label', wellId: well.id};

                let nodes = [];
                for (let nodeIndex in well.nodes) {
                    let node = well.nodes[nodeIndex];
                    let [x, y, z] = getWellXYZ(node, this.gridProperties);
                    let segments = 30;

                    let radius = this.getMarkerSize();
                    let color = COLOR_NODE;
                    let geometry = new THREE.SphereGeometry(radius, segments, segments);
                    let material = new THREE.MeshStandardMaterial({color});
                    let perforationSphere = new THREE.Mesh(geometry, material);
                    perforationSphere.position.set(x, y, z * this.zScale);
                    perforationSphere.userData = {
                        type: 'perforation',
                        wellId: well.id,
                        nodeIndex
                    }
                    nodes.push(perforationSphere);
                    this.nodeGroup.add(perforationSphere);
                    this.wellsGroup.add(perforationSphere);
                }

                this.wellsGroup.add(label);
                this.wellsGroup.add(path);

                this.wellObjects.push({id: well.id, path, material, geometry, label, nodes});
            }

            this.scene.add(this.nodeGroup);
            this.scene.add(this.wellsGroup);
        },
        addConnections() {
            if (!this.nodes || this.nodes?.lenght == 0) {
                return;
            }

            this.connectionObjects = [];
            this.connectionGroup = new THREE.Group();
            for (let connectionIndex in this.connections) {
                let connection = this.connections[connectionIndex];
                let nodes = connection.map(nodeIndex => this.nodes[nodeIndex]);
                if (!nodes) {
                    continue;
                }

                let points3d = nodes
                    .map(node => {
                        let coords = getWellXYZ(node, this.gridProperties);
                        if (!coords) {
                            return null;
                        }

                        let [x, y, z] = coords;
                        return new THREE.Vector3(x, y, z * this.zScale);
                    })
                    .filter(item => item !== null);

                if (!points3d) {
                    continue;
                }

                let startPoint = points3d[0];
                let endPoint = points3d[points3d.length - 1];
                if (!startPoint || !endPoint) {
                    continue;
                }

                let dir = new THREE.Vector3();
                dir.subVectors(endPoint, startPoint).normalize();

                let length = Math.abs(startPoint.distanceTo(endPoint));

                // let material = new THREE.LineBasicMaterial({color: COLOR_CONNECTION});
                // let geometry = new THREE.BufferGeometry().setFromPoints(points3d);
                // let line = new THREE.Line(geometry, material);

                let line = new THREE.ArrowHelper(dir, startPoint, length, COLOR_CONNECTION, this.arrowHeadSize, this.arrowHeadSize * 0.2);
                line.userData = {type: 'connection', connectionIndex};
                this.connectionObjects.push(line);
                this.connectionGroup.add(line);

                if (this.showConnectionsHeightDiff) {
                    let middlePoint = startPoint.lerp(endPoint, 0.5);

                    let startNode = nodes[0];
                    let endNode = nodes[nodes.length - 1];
                    let diff = endNode.z_coord - startNode.z_coord;
                    let text = String(diff);
                    if (diff > 0) {
                        text = '+' + text + ' ↑';
                    }
                    else if (diff < 0) {
                        text += ' ↓';
                    }
                    else {
                        text = '0 =';
                    }

                    let fontSize = this.fontSize * 0.4;
                    let label = new TextSprite({
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        color: COLOR_LABEL,
                        fontSize,
                        text
                    });

                    label.position.set(middlePoint.x, middlePoint.y, middlePoint.z * this.zScale + fontSize);
                    label.userData = {type: 'label', connectionIndex};
                    this.connectionObjects.push(label);
                    this.connectionGroup.add(label);
                }
            }

            this.scene.add(this.connectionGroup);
        },
        addNodeLayers() {
            if (!this.wells) {
                return;
            }

            let allNodes = [];
            for (let well of this.wells) {
                for (let node of well.nodes) {
                    allNodes.push(node);
                }
            }

            let sizeX = Math.max.apply(Math, allNodes.map(node => node.x_coord));
            let sizeY = Math.max.apply(Math, allNodes.map(node => node.y_coord));

            let cellHeight = this.cellSize ? this.cellSize[2] : 1;
            let layers = getNodeLayers(allNodes, cellHeight);

            this.layerGroup = new THREE.Group();
            for (let layerNodes of layers) {
                if (!layerNodes) {
                    continue;
                }

                let avgZ = layerNodes.reduce((sum, node) => {
                    let [x, y, z] = getWellXYZ(node, this.gridProperties);
                    return sum + z;
                }, 0) / layerNodes.length;

                let geometry = new THREE.PlaneGeometry(sizeX, sizeY);
                let material = new THREE.MeshBasicMaterial({
                    color: COLOR_LAYER_PLANE,
                    opacity: 0,
                    side: THREE.DoubleSide
                });
                material.transparent = true;
                let plane = new THREE.Mesh(geometry, material);
                plane.position.set(sizeX / 2, sizeY / 2, avgZ);
                this.layerGroup.add(plane);
            }

            this.scene.add(this.layerGroup);
        },
        startProcessingState() {
            return this.$store.commit('grid/setProcessing', true);
        },
        async endProcessingState() {
            return this.$store.commit('grid/setProcessing', false);
        },
        startRenderingState() {
            this.isRendering = true;
        },
        endRenderingState() {
            this.isRendering = false;
        },
        async updateGrid(now = true) {
            if (this.isInitializing) {
                return;
            }

            if (!this.gridMeshFile || !this.gridProperties || !this.gridProperties?.cell_size) {
                return;
            }

            this.startProcessingState();
            let updater = async () => {
                await this.init();

                if (this.showPlane) {
                    this.addGridToScene();
                }

                if (this.showAxis) {
                    this.addAxisToScene();
                }

                await this.addCubesToScene();

                if (this.showWells) {
                    this.addWellsToScene();
                }

                if (this.showConnections) {
                    this.addConnections();
                }

                this.addNodeLayers();
                this.updateCameraDistance();

                //this.addTestCubeXYZ(0, 0, 0);
                await this.render();
                await this.endProcessingState();
                await this.afterInit();
            }

            if (now) {
                await updater();
            }
            else {
                this.$nextTick(updater);
            }
        },
        getRayIntersects(event, searchIn = null) {
            if (searchIn === this.mesh && !this.faceToCellIndex) {
                return [];
            }

            let pointer = new THREE.Vector2()
            let viewport = this.renderer.domElement.getBoundingClientRect();
            pointer.x = ((event.clientX - viewport.left) / viewport.width) * 2 - 1;
            pointer.y = -((event.clientY - viewport.top) / viewport.height) * 2 + 1;
            this.raycaster.setFromCamera(pointer, this.camera);

            if (!searchIn) {
                searchIn = this.scene;
            }

            if (!searchIn) {
                return [];
            }

            return this.raycaster.intersectObject(searchIn);
        },
        onMouseMove(event = null, editMode = null) {
            if (editMode === null) {
                editMode = this.editMode;
            }

            if (editMode === 'move') {
                return;
            }

            if (event === null) {
                let rect = this.$refs.scene.getBoundingClientRect();
                event = new PointerEvent("pointermove", {
                    clientX: rect.x,
                    clientY: rect.y,
                });
            }

            if (this.editMode === 'cell') {
                let intersects = this.getRayIntersects(event, this.mesh);
                if (intersects.length > 0) {
                    let intersectingFaceIndex = intersects[0].faceIndex;
                    let highlightCellIndex = this.faceToCellIndex[intersectingFaceIndex];
                    this.hoverCellIndex = highlightCellIndex;
                    let point = intersects[0].point;
                    this.addHoverCubeToCell(highlightCellIndex, point.x, point.y, point.z);
                    this.render();
                }
                else {
                    this.hoverCellIndex = 0;
                }
            }
            else {
                let hoverOn = null;
                let hoverOff = null;
                switch (editMode) {
                    case 'add':
                        hoverOn = mesh => {
                            mesh.material.opacity = 0.2;
                        }
                        hoverOff = mesh => {
                            mesh.material.opacity = 0;
                        }
                        break;
                    case 'edit':
                        hoverOn = mesh => {
                            let wellId = mesh.userData.wellId;
                            if (wellId) {
                                for (let wellMesh of this.wellsGroup.children) {
                                    if (wellMesh.userData.wellId === wellId) {
                                        wellMesh.pre_hover_color = wellMesh.material.color.getHex();
                                        wellMesh.material.color.set(COLOR_NODE_HOVER);
                                    }
                                }
                            }
                            else {
                                mesh.pre_hover_color = mesh.material.color.getHex();
                                mesh.material.color.set(COLOR_NODE_HOVER);
                            }
                        }
                        hoverOff = mesh => {
                            let wellId = mesh.userData.wellId;
                            if (wellId) {
                                for (let wellMesh of this.wellsGroup.children) {
                                    if (wellMesh.userData.wellId === wellId && wellMesh.pre_hover_color) {
                                        wellMesh.material.color.setHex(wellMesh.pre_hover_color);
                                        delete wellMesh.pre_hover_color;
                                    }
                                }
                            }
                            else {
                                if (mesh.pre_hover_color) {
                                    mesh.material.color.setHex(mesh.pre_hover_color);
                                    delete mesh.pre_hover_color;
                                }
                            }
                        }
                        break;
                    case 'connect':
                    case 'delete':
                        hoverOn = mesh => {
                            mesh.pre_hover_color = mesh.material.color.getHex();
                            mesh.material.color.set(COLOR_NODE_HOVER);
                        }
                        hoverOff = mesh => {
                            let color = mesh.pre_hover_color ? mesh.pre_hover_color : COLOR_NODE;
                            if (color === mesh.material.color.getHex()) {
                                color = COLOR_NODE;
                            }

                            mesh.material.color.setHex(color);
                            delete mesh.pre_hover_color;
                        }
                        break;
                    case 'disconnect':
                        hoverOn = mesh => {
                            mesh.material.color.set(COLOR_CONNECTION_HOVER);
                        }
                        hoverOff = mesh => {
                            mesh.material.color.set(COLOR_CONNECTION);
                        }
                        break;
                }

                if (!this.searchIn) {
                    return;
                }

                let intersects = this.getRayIntersects(event, this.searchIn);
                let intersectObject = intersects.length > 0 ? intersects[0].object : null;
                if (intersectObject) {
                    if (this.hoverObject !== intersectObject) {
                        if (this.hoverObject !== null && hoverOff) {
                            hoverOff(this.hoverObject);
                            this.fastRender();
                        }

                        this.hoverObject = intersectObject;
                        if (hoverOn) {
                            hoverOn(this.hoverObject);
                            this.fastRender();
                        }
                    }
                }
                else if (this.hoverObject) {
                    if (hoverOff) {
                        hoverOff(this.hoverObject);
                        this.fastRender();
                    }
                    this.hoverObject = null;
                }
            }
        },
        getWellOfIntersection(intersects) {
            let wellIds = intersects
                ? intersects
                    .map(intersect => intersect?.object?.userData?.wellId || null)
                    .filter(item => Boolean(item))
                : [];

            if (wellIds && wellIds[0]) {
                let wellId = wellIds[0];
                let well = this.wells.find(well => well.id === wellId);
                if (well) {
                    return well;
                }
            }

            return null;
        },
        getNodeIndexOfIntersection(intersects) {
            let nodeIndexes = intersects
                ? intersects
                    .map(intersect => intersect?.object?.userData?.nodeIndex || null)
                    .filter(item => item !== null && typeof (item) !== 'undefined')
                : [];

            return nodeIndexes.length > 0 ? nodeIndexes[0] : null;
        },
        selectNode(well, nodeIndex, mesh) {
            this.selectedWell = well;
            this.selectedNodeIndex = nodeIndex;
            if (mesh) {
                this.selectedMesh = mesh;

                if (mesh.pre_hover_color) {
                    mesh.pre_select_color = mesh.pre_hover_color;
                }
                else {
                    mesh.pre_select_color = mesh.material.color.getHex();
                }

                mesh.material.color.set(COLOR_NODE_HOVER);
                mesh.pre_hover_color = mesh.material.color.getHex();
            }

            this.fastRender();
        },
        unselectNode() {
            this.selectedWell = null;
            this.selectedNodeIndex = null;
            if (this.selectedMesh) {
                if (this.selectedMesh.pre_select_color) {
                    if (this.selectedMesh.pre_hover_color) {
                        this.selectedMesh.pre_hover_color = this.selectedMesh.pre_select_color;
                    }

                    this.selectedMesh.material.color.set(this.selectedMesh.pre_select_color);
                    delete this.selectedMesh.pre_select_color;
                }
                else if (this.selectedMesh.pre_hover_color) {
                    this.selectedMesh.material.color.set(this.selectedMesh.pre_hover_color);
                    delete this.selectedMesh.pre_hover_color;
                }
                this.selectedMesh = null;
            }
            this.fastRender();
        },
        onClick(event) {
            event.stopPropagation();

            if (this.editMode === 'move') {
                return;
            }

            if (!this.searchIn) {
                return;
            }

            let intersects = this.getRayIntersects(event, this.searchIn);

            if (this.editMode === 'add') {
                let layer = intersects[0];
                if (layer && layer.point) {
                    this.$emit('addWell', layer.point);
                    this.editMode = 'edit';
                    return;
                }
            }

            if (this.editMode === 'edit') {
                let well = this.getWellOfIntersection(intersects);
                if (well) {
                    this.$emit('clickWell', well);
                }
            }

            if (this.editMode === 'delete') {
                let well = this.getWellOfIntersection(intersects);
                let nodeIndex = this.getNodeIndexOfIntersection(intersects);
                if (well && nodeIndex !== null) {
                    this.$emit('deleteWell', well, nodeIndex);
                    this.editMode = 'edit';
                    return;
                }
            }

            if (this.editMode === 'connect') {
                let well = this.getWellOfIntersection(intersects);
                let nodeIndex = this.getNodeIndexOfIntersection(intersects);
                let intersectObject = intersects.length > 0 ? intersects[0].object : null;
                if (well && nodeIndex !== null) {
                    if (this.selectedWell) {
                        if (this.selectedWell === well) {
                            let prevNodeIndex = this.selectedNodeIndex;
                            this.unselectNode();

                            if (prevNodeIndex !== nodeIndex) {
                                this.selectNode(well, nodeIndex, intersectObject);
                            }
                        }
                        else {
                            let fromWell = this.selectedWell;
                            let toWell = well;
                            let fromNodeIndex = this.selectedNodeIndex;
                            let toNodeIndex = nodeIndex;
                            this.$emit("addConnection", fromWell, toWell, fromNodeIndex, toNodeIndex);
                            this.unselectNode();
                        }
                    }
                    else {
                        this.selectNode(well, nodeIndex, intersectObject);
                    }
                }
            }

            if (this.editMode === 'disconnect') {
                let intersectObject = intersects.length > 0 ? intersects[0].object : null;
                if (intersectObject && typeof (intersectObject?.userData?.connectionIndex) !== 'undefined') {
                    this.$emit('deleteConnection', intersectObject.userData.connectionIndex);
                }
            }
        }
    },
    computed: {
        availableProperties() {
            if (!this.textures) {
                return this.properties;
            }

            return this.properties.filter(propItem => Object.keys(this.textures).includes(propItem.value));
        },
        constants() {
            let loaded = this.$store.state.grid.constants;
            let input = this.$store.state.grid.inputConstants;
            return Object.assign(loaded, input);
        },
        gridProperties() {
            return this.$store.state.grid.gridProperties || null;
        },
        gridSize() {
            return this.$store.state.grid.gridProperties?.size || null;
        },
        cellSize() {
            let cellSize = this.$store.state.grid.gridProperties?.cell_size || null;
            return cellSize;
        },
        faceToCellIndex() {
            return this.$store.state.grid.gridProperties?.face_to_cell_index || null;
        },
        ijkIndex() {
            return this.$store.state.grid.gridProperties?.ijk_index || null;
        },
        isLoading() {
            return this.$store.state.grid.loading;
        },
        isProcessing() {
            return this.$store.state.grid.processing;
        },
        isDisabled() {
            return !this.cellSize || !this.gridSize;
        },
        gridGeometry() {
            return this.mesh ? this.mesh.children[0].children[0].geometry : null;
        },
        errorLoadingGrid() {
            return Boolean(this.$store.state.grid.gridFileError);
        },
        searchIn() {
            let searchIn = null;
            switch (this.editMode) {
                case 'add':
                    searchIn = this.layerGroup;
                    break;
                case 'edit':
                    searchIn = this.wellsGroup;
                    break;
                case 'connect':
                case 'delete':
                    searchIn = this.nodeGroup;
                    break;
                case 'disconnect':
                    searchIn = this.connectionGroup;
                    break;
            }

            return searchIn;
        },
        zScale() {
            return this.zScaleRaw ? parseFloat(this.zScaleRaw) : 1;
        },
        connectionsAutoload: {
            get() {
                return this.$store.state.grid.connectionsAutoload;
            },
            set(value) {
                this.$store.commit('grid/setConnectionsAutoload', value);
            }
        },
        fontSize: {
            get() {
                return this.$store.state.grid.fontSize;
            },
            set(value) {
                this.$store.commit('grid/setFontSize', value);
            }
        },
        wellMarkerSize: {
            get() {
                return this.$store.state.grid.wellMarkerSize;
            },
            set(value) {
                this.$store.commit('grid/setWellMarkerSize', value);
            }
        },
    }
}
</script>

<style lang="scss">
.container {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 0;
}

.scene {
    position: relative;
    padding: 0;
}

.grid-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-width: 500px;
    min-height: 500px;
    border: 1px solid rgba(0, 0, 0, 0.6);

    &__holder {
        width: 100%;
        height: 100%;
    }
}

.progress-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #e1e1e180;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
}

.params {
    display: none;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: white;
    border-top: 1px solid rgba(181, 181, 181);

    .theme--light {
        &.v-label, &.v-icon {
            color: rgba(0, 0, 0, 0.54);
        }
    }

    .history-slider {
        width: 300px;

        .v-input__slot {
            margin-bottom: 0 !important;
        }

        .v-slider--horizontal {
            min-height: 24px;
        }
    }
}

.grid-contailer__inited {
    .params {
        display: block;
    }
}
</style>
